import {
  dispatchMetaPixelEvent
} from "./chunk-SG654XWV.js";
import {
  dispatchRudderEvent
} from "./chunk-UFJPUFYT.js";
import {
  Analytics
} from "./chunk-YBHTLIZ2.js";
import {
  toKebabCase
} from "./chunk-QL3LGFZE.js";

// src/index.ts
var trackEvent = (event) => {
  dispatchMetaPixelEvent(event);
  dispatchRudderEvent(event);
};
export {
  Analytics,
  toKebabCase,
  trackEvent
};
